import { useEffect, useState } from 'react';
import { ChefHat } from 'lucide-react';
import { api } from '../../lib/spizirnaUi';

const BARVA = '#F59E0B';

/**
 * Kuchyňská stanice produktu — výjimka ze stanice kategorie.
 *
 * Většina produktů stanici dědí z kategorie (Pizza → Kuchyně 1). Tady se
 * dá přebít jednotlivě, třeba „Pizza roll“ na Kuchyni 2. Ukazuje se, jen
 * když má provoz víc než jednu stanici.
 *
 * Hodnota se ukládá s ostatními poli produktu (tlačítko Uložit).
 */
export default function StaniceProduktu({ value, onChange, isDark }) {
    const [stanice, setStanice] = useState([]);

    useEffect(() => {
        api('/api/kds-stanice').then(d => setStanice((d || []).filter(s => s.aktivni))).catch(() => {});
    }, []);

    if (stanice.length <= 1) return null;

    const muted = isDark ? 'rgba(255,255,255,0.4)' : 'var(--text-muted)';
    const border = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';

    return (
        <div className="rounded-xl px-4 py-3" style={{
            background: isDark ? 'rgba(255,255,255,0.03)' : 'var(--surface-base)',
            border: `1px solid ${border}`,
        }}>
            <div className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>Kuchyňská stanice</div>
            <p className="text-[11px] mb-2" style={{ color: muted }}>
                Na kterém kuchyňském displeji se produkt zobrazí. Když tahle kuchyně nemá připojený displej, spadne na nejbližší nižší.
            </p>
            <div className="flex flex-wrap gap-1.5">
                {[{ id: null, nazev: 'Podle kategorie' }, ...stanice].map(s => {
                    const on = (value ?? null) === s.id;
                    return (
                        <button key={s.id ?? 'kategorie'} type="button" onClick={() => onChange(s.id)}
                            className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium"
                            style={{
                                background: on ? `${BARVA}26` : 'transparent',
                                border: `1px solid ${on ? BARVA : border}`,
                                color: on ? BARVA : 'var(--text-primary)', cursor: 'pointer',
                            }}>
                            {s.id
                                ? <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.barva || muted }} />
                                : <ChefHat size={12} />}
                            {s.nazev}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
